import { render, staticRenderFns } from "./ChallengeRanking.vue?vue&type=template&id=a7192348&"
import script from "./ChallengeRanking.controller.js?vue&type=script&lang=js&"
export * from "./ChallengeRanking.controller.js?vue&type=script&lang=js&"
import style0 from "./ChallengeRanking.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports